<template>
  <fieldset :class="{ error: error }">
    <h1>{{ $t("auth-form-login-title") }}</h1>
    <div class="form-group">
      <label>
        {{ $t("auth-login-form-email-label") }}
        <p v-if="error" class="error-description">
          {{ $t("auth-form-invalid") }}
        </p>
        <input
          type="email"
          name="username"
          v-model.trim="username"
          :placeholder="$t('auth-login-form-email-placeholder')"
          @keydown="clearValidation"
        />
      </label>
      <error-icon
        v-if="error"
        fillColor="#ff4d4d"
        width="18"
        height="18"
        cssClass="icon"
      ></error-icon>
    </div>
    <div class="form-group">
      <label>
        {{ $t("auth-login-form-password-label") }}
        <input
          type="password"
          name="password"
          autocomplete="off"
          v-model.trim="password"
          :placeholder="$t('auth-login-form-password-placeholder')"
          @keydown="clearValidation"
        />
      </label>
      <error-icon
        v-if="error"
        fillColor="#ff4d4d"
        width="18"
        height="18"
        cssClass="icon"
      ></error-icon>
    </div>
    <div class="form-group">
      <button v-if="loading" type="submit" class="primary" disabled>
        {{ $t("loading") }}
      </button>
      <button
        v-else
        type="submit"
        class="primary"
        @click.prevent="login"
        :disabled="!this.username || !this.password || !formValid"
      >
        {{ $t("auth-form-login") }}
        <long-arrow width="25" height="16" weight="solid"></long-arrow>
      </button>
    </div>
    <router-link :to="{ name: 'recover' }" class="right">
      <p>{{ $t("auth-form-recover-link") }}</p>
    </router-link>
  </fieldset>
</template>

<script>
import { mapState } from "vuex";
import LongArrow from "@/components/icons/LongArrowIcon";
import ErrorIcon from "@/components/icons/ErrorIcon";

export default {
  name: "LoginForm",
  components: {
    LongArrow,
    ErrorIcon
  },
  data() {
    return {
      error: null,
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapState("common", ["loading"]),
    formValid() {
      return this.username.match(/.@./g);
    }
  },
  methods: {
    login() {
      if (this.error) return;
      let data = {
        username: this.username,
        password: this.password
      };
      this.$store
        .dispatch("auth/login", data)
        .then(() => this.$router.push({ name: "dashboard" }))
        .catch(err => {
          this.resetForm();
          this.error = err;
        });
    },
    resetForm() {
      this.username = "";
      this.password = "";
    },
    clearValidation() {
      if (!this.error) return;
      this.error = null;
      this.resetForm();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/styles/variables";
.error {
  .form-group {
    input {
      &:focus {
        box-shadow: 0 0 0 2px lighten($error-color, 30%);
      }
    }
  }
}
.form-group {
  position: relative;
  .icon {
    position: absolute;
    right: 0;
    transform: translateX(25px) translateY(-30px);
  }
}
</style>
